// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Agreement.yaml
// Generated: 2026-10-19T08:01:51.126Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateAgreement, UpdateAgreement, Agreement } from '@/types/forestry/Agreement';

/**
 * Agreement Service
 * CRUD operations for Agreement via the ABP API.
 */
export const agreementService = new EntityService<Agreement, CreateAgreement, UpdateAgreement>(
  '/api/forestry/agreement',
  'Agreement',
);
